var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyePasswordView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_3",
    "data-name": "Calque 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191.86 175.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#afafaf;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.56,83.54c-1.7-2.27-42.6-55.29-94.63-55.29S3,81.27,1.31,83.54a6.39,6.39,0,0,0,0,7.74C3,93.55,43.9,146.57,95.93,146.57s92.93-53,94.63-55.29A6.36,6.36,0,0,0,190.56,83.54ZM95.93,133.83c-38,0-71.12-34.6-81.26-46.37C24.77,75.61,57.77,41,95.93,41s71.12,34.6,81.26,46.37C167.05,99.21,134.08,133.83,95.93,133.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.93,59.11a28.3,28.3,0,1,0,28.3,28.3h0A28.34,28.34,0,0,0,95.93,59.11Zm0,43.81a15.51,15.51,0,1,1,15.51-15.51h0A15.54,15.54,0,0,1,95.93,102.92Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.18,
    y: -11.65,
    width: 14.98,
    height: 201.2,
    rx: 7.49,
    transform: "translate(-33.06 65.3) rotate(-32.73)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyePasswordView);
export default __webpack_public_path__ + "static/media/eye_password_view.22ef4cfe.svg";
export { ForwardRef as ReactComponent };